import { Flex, FlexProps, Spinner } from '@cmpsr/components';

export default function Loading(props: FlexProps) {
  return (
    <Flex alignItems="center" h="100vh" w="full" justifyContent="center" {...props}>
      <Spinner />
    </Flex>
  );
}
